// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-screen > .is-fullscreen > .el-dialog__header {\n  display: none;\n}\n.full-screen > .is-fullscreen > .el-dialog__body {\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
